import React from 'react';
import { gql } from '@apollo/client';
import loadable from '@loadable/component';
import { SinglePumoModule, SINGLE_PUMO_MODULE_FRAGMENT } from '../../components/SinglePumoModule';
import { TrunkshowHeaderModulePumoFragment, TrunkshowPageQuery } from '../../generated/types';
import { useAdminMode } from '../../components/AdminMode/AdminModeProvider';
import {
  TrunkshowHeaderCountdown,
  TRUNKSHOW_HEADER_COUNTDOWN_FRAGMENT
} from './TrunkshowHeaderCountdown';
import { TrunkshowHeaderBrandFollowButton } from './TrunkshowHeaderBrandFollowButton';

type TrunkshowHeaderModuleTrunkshow = NonNullable<
  NonNullable<TrunkshowPageQuery['trunkshowPage']>['trunkshow']
>;

const AdminModePumoModuleOverlay = loadable(
  () => import('../../components/AdminMode/AdminModePumoModuleOverlay')
);

export interface Props {
  trunkshowHeaderModulePumo: TrunkshowHeaderModulePumoFragment;
  trunkshowHeaderModuleTrunkshow: TrunkshowHeaderModuleTrunkshow;
  hideCtaUnderline: boolean;
}

export const TRUNKSHOW_HEADER_MODULE_PUMO_FRAGMENT = gql`
  fragment TrunkshowHeaderModulePumoFragment on SinglePumoModule {
    ...SinglePumoModuleFragment
  }
  ${SINGLE_PUMO_MODULE_FRAGMENT}
`;

export const TRUNKSHOW_HEADER_MODULE_TRUNKSHOW_FRAGMENT = gql`
  fragment TrunkshowHeaderModuleTrunkshowFragment on Trunkshow {
    ...TrunkshowHeaderCountdownFragment
  }
  ${TRUNKSHOW_HEADER_COUNTDOWN_FRAGMENT}
`;

export const TrunkshowHeaderModule: React.FC<Props> = ({
  trunkshowHeaderModulePumo,
  trunkshowHeaderModuleTrunkshow,
  hideCtaUnderline
}) => {
  const { enabled: adminModeEnabled } = useAdminMode();

  const content = (
    <SinglePumoModule
      beforeEyebrow={
        trunkshowHeaderModulePumo.moduleType?.includes('TrunkshowHeaderModule') && (
          <TrunkshowHeaderCountdown trunkshowHeaderCountdown={trunkshowHeaderModuleTrunkshow} />
        )
      }
      singlePumoModule={trunkshowHeaderModulePumo}
      normalizePumoStyles={false}
      spaceBetween
      hideCtaUnderline={hideCtaUnderline}
    >
      {trunkshowHeaderModulePumo.moduleType?.includes('TrunkshowHeaderModule') && (
        <TrunkshowHeaderBrandFollowButton trunkshow={trunkshowHeaderModuleTrunkshow} />
      )}
    </SinglePumoModule>
  );

  if (adminModeEnabled) {
    return (
      <AdminModePumoModuleOverlay fallback={content} modelId={trunkshowHeaderModulePumo.modelId}>
        {content}
      </AdminModePumoModuleOverlay>
    );
  }

  return content;
};
